const selectStyles = {
  menuPortal: (base) => ({
    ...base,
    zIndex: 9999,
  }),
  menu: (base) => ({
    ...base,
    zIndex: 9999,
  }),
  control: (base) => ({
    ...base,
    minHeight: "48px",
    border: "1px solid #ced4da",
    borderRadius: "0.375rem",
    "&:hover": {
      borderColor: "#86b7fe",
    },
    "&:focus-within": {
      borderColor: "#86b7fe",
      boxShadow: "0 0 0 0.25rem rgba(13, 110, 253, 0.25)",
    },
  }),
};

export default selectStyles;
